import {Component, OnInit} from "@angular/core";
import {SharedService} from "../../../services/shared.service";
import {HttpApiService} from "../../../services/http-api.service";
import {EndpointsService} from "../../../services/endpoints.service";
import {ActivatedRoute} from "@angular/router";

declare var sha256: any;
@Component({
  selector: 'app-checkout',
  templateUrl: './checkout.component.html'
})
export class CheckoutComponent implements OnInit {

  private order: any = {};
  private isCreated: boolean = false;
  private hasError: boolean = false;
  private errorMessage: any;
  private successMessage: string;
  private oneBillResponse: string = "";

  constructor(private sharedService: SharedService,
              private api: HttpApiService,
              private endpointService: EndpointsService,
              private activatedRoute: ActivatedRoute) {
    this.order.pricingPlanId = this.sharedService.getParameter("selectedPricingPlan");
  }

  ngOnInit() {
    let self = this;
    this.sharedService.setParameter("oneBillResponse", {});
    this.activatedRoute.queryParams.subscribe(
      (param: any) => {
        self.oneBillResponse = param.responseStatus;
        self.sharedService.setParameter("oneBillResponse", param);
      });
  }

  placeOrder(order) {
    this.errorMessage = "";
    this.hasError = false;
    this.api.post(this.endpointService.getPlaceOrderUrl(), order, true)
      .subscribe((response: any) => {
          this.hasError = false;
          this.successMessage = "Order id : " + response.orderNumber;
          this.isCreated = true;
        },
        error=> {
          this.errorMessage = error;
          this.hasError = true;
        });
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/buyer/checkout/checkout.component.ts